import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var AdminUpdateDesignationRes;
export const AdminUpdateDesignationTodo = createAsyncThunk('adminAdminUpdateDesignation', async (data) => {
    console.log(data)
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL +  `admin/designation_admin/${data?.id}`,
            data: {
                "name": data?.designation,
                "company_id": localStorage.getItem('companyId'),
                "status": data?.status,
                "modified_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AdminUpdateDesignationRes = res.data

    } catch (error) {
        return AdminUpdateDesignationRes = error.response.data
    }
})